import Chain33Rpc from 'chain33-rpc-api'

export default new Chain33Rpc('/api', null, (e: Error) => {
  throw e
})